export default __webpack_public_path__ + "static/media/forceoflightning.430646d1.png";